<template>
	<div class="bg-white px-3 index" >
		<div class="add_tits" ref="titles">
			<el-form class="form-inlines u-f u-jsb" :inline="true">
				<div>
					<el-form-item label="模糊搜索">
						<el-select v-model="lb_value" placeholder="请选择" clearable size="small" filterable>
							<el-option v-for="item in  lb_options" :key="item.id" :label="item.text" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="银行卡信息">
						<el-input v-model="bank_value" size="small" placeholder="请输入银行卡信息"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="ibox-content">
			<el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
				<el-table-column prop="info.real_name" label="用户" show-overflow-tooltip></el-table-column>
				<el-table-column prop="amount" label="提现金额">
					<template slot-scope="scope">{{scope.row.amount}}元</template>
				</el-table-column>
				<el-table-column prop="tax" label="税">
					<template slot-scope="scope">{{scope.row.tax}}元</template>
				</el-table-column>
				<el-table-column prop="actual" label="实际到账">
					<template slot-scope="scope">{{scope.row.actual}}元</template>
				</el-table-column>
				<el-table-column prop="banks.name" label="开户姓名" show-overflow-tooltip></el-table-column>
				<el-table-column prop="banks.bank" label="银行名称" show-overflow-tooltip></el-table-column>
				<el-table-column prop="banks.bank_outlets" label="银行网点" show-overflow-tooltip></el-table-column>
				<el-table-column prop="banks.bank_card" label="收款账号" width="150"></el-table-column>
				<el-table-column prop="create_time" label="添加时间" width="180">
				
				</el-table-column>
				<el-table-column prop="state" label="状态" width="150">
					<template slot-scope="scope">
						<span>{{({1:'待处理',2:'已处理'})[scope.row.state]}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" fixed="right">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" v-if="scope.row.state==1"
							@click="handleEdit(scope.row,scope.$index)">处理</el-button>
						<el-button size="mini" type="info" v-else>已处理</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="处理" :visible.sync="dialogVisible" center top="200px" width="40%" class="dialogs">
			<el-divider></el-divider>
			<div class="boxx">
				<el-tabs type="border-card" v-model="activeName">
					<el-tab-pane label="手动提现(大于200元)" name="1">
						<el-form class="txbox" :model="datas">
							<el-form-item label="专家：">
								{{datas.info?datas.info.real_name:''}}
							</el-form-item>
							<el-form-item label="提现金额：">
								<span style="color:red">{{datas.amount}}</span> 元
							</el-form-item>
							<el-form-item label="实际到账：">
								<span style="color:red">{{datas.actual}}</span> 元
							</el-form-item>
						</el-form>
					</el-tab-pane>
					<el-tab-pane label="自动提现(小于200元)" name="2">
						<el-form class="txbox" :model="datas">
							<el-form-item label="专家：">
								{{datas.info?datas.info.real_name:''}}
							</el-form-item>
							<el-form-item label="提现金额：">
								<span style="color:red">{{datas.amount}}</span> 元
							</el-form-item>
							<el-form-item label="实际到账：">
								<span style="color:red">{{datas.actual}}</span> 元
							</el-form-item>
							<el-form-item label="资金备注：">
								<el-input v-model="desc" type="textarea" :rows="3" placeholder="请输入内容"></el-input>
							</el-form-item>
						</el-form>
					</el-tab-pane>

				</el-tabs>
			</div>

			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button @click="submit()" size="small" type="primary" :loading="subloading">提 交</el-button>
				<el-button @click="dialogVisible = false" size="small">取 消</el-button>
			</span>
		</el-dialog>

	</div>
</template>


<script>
	import {
		mapState
	} from 'vuex'
	import tinymce from '@/components/common/tinymce.vue';
	export default {
		components: {
			tinymce,
		},
		data() {
			return {
				lb_value: '',
				lb_options: [{
						id: 1,
						text: '待处理'
					},
					{
						id: 2,
						text: '已处理'
					},
				],

				loading: false,
				tableData: [],
				count: 0,
				currentPage: 1,
				pagesize: 10,
				height: null,
				// 
				eid: '0',
				dialogVisible: false,
				subloading: false,

				// 
				date: xaoi.date,
				bank_value: '',
				activeName: '1',
				datas: '',
				desc: '',

			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		created() {
			if (this.$route.query.type) {
				this.lb_value = this.$route.query.type - 0
			}
		},
		mounted() {
			let that = this
			that.getHeight()
			this.begin()

		},
		methods: {

			getHeight() {
				let that = this
				var titles = that.$refs.titles.offsetHeight
				that.height = window.innerHeight - titles - 200 + 'px'
				window.onresize = () => {
					var titles = that.$refs.titles.offsetHeight
					that.height = window.innerHeight - titles - 200 + 'px'
				}
			},

			// 搜索
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 10
				that.search()
			},
			async search() {
				let that = this
				that.tableData = []
				that.loading = true
				let params = {
					limit: this.pagesize,
					page: this.currentPage,
					sousuo: this.bank_value,
					type: this.lb_value,
				}
				let res = await this.ajax('tools/pretax/tx_lis', params)
				if (res.code == 200) {
					that.loading = false
					that.tableData = res.data.data
					that.tableData.forEach(ele => {
						ele.banks = JSON.parse(ele.bank)
					})
					that.count = res.data.count
				}

			},
			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},


			//编辑
			handleEdit(row, index) {
				this.dialogVisible = true
				this.activeName = '1'
				this.desc = ''
				this.datas = row
			},
			submit() {
				let that = this
				let params = {}
				this.$confirm('确定此提现可以通过吗, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					params = {
						id: this.datas.id,
						desc: that.desc,
						tx_type: that.activeName
					}
					// this.subloading = true
					let res = await this.ajax('tools/pretax/tx_add', params)
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: '成功!'
						});
						this.dialogVisible = false
						this.search()
					} else {
						this.$message.error(res.msg);
					}
					this.subloading = false

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},

			gettimes() {
				let nowDate = new Date();
				let year = nowDate.getFullYear();
				let month = nowDate.getMonth() + 1;
				let day = nowDate.getDate();
				let hour = nowDate.getHours(); //获取系统时，
				let min = nowDate.getMinutes(); //分
				let sec = nowDate.getSeconds(); //秒
				month = month > 9 ? month : '0' + month
				day = day > 9 ? day : '0' + day
				hour = hour > 9 ? hour : '0' + hour
				min = min > 9 ? min : '0' + min
				sec = sec > 9 ? sec : '0' + sec
				return `${year}-${month}-${day} ${hour}:${min}`;
			},
		},
		watch: {
			'activeName'(nval, oval) {
				if (nval == 1) {
					this.desc = ''
				}
			}
		},

	};
</script>


<style lang='scss'>
	.con_de {
		/* border: 1px solid red; */
		/* width: 200px; */
		width: 100%;
		max-height: 200px;
		overflow-y: scroll;
		line-height: 18px;
		position: relative;
		top: 7px;
		background-color: rgb(247, 245, 245);
		border-radius: 5px;
		padding: 5px;
	}

	.imgs {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		margin-right: 5px;
	}

	.lefts {
		max-height: 500px;
		overflow: auto;
	}

	.delt {
		color: red;
		font-size: 20px;
	}

	.blues {
		color: #409eff;
	}

	.concon {
		background: #f5f5f5;
		padding: 10px;
		border-radius: 10px;
	}

	.zanbtn {
		width: 30px;
		display: flex;
		/* border: 1px solid red; */
		cursor: pointer;
	}

	.zanbtn img {
		width: 100%;
		display: block;
	}

	.singleimg {
		width: 100px;
		width: 100px;
	}

	.singleimg img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.imgbox {
		display: flex;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.tablimg {
		margin: 2px 5px;
	}

	.boxx {
		padding: 0 20px;
	}

	.txbox {
		.el-form-item {
			margin-bottom: 0;
		}
	}
</style>